module.exports = __webpack_public_path__ + "img/skyward-harp.90840a85.webp";